<template>
	<GlobalModal v-model="isOpen" @close="emit('close')">
		<div class="global-modal-generic">
			<div class="global-modal-generic__text">
				<span v-if="genericTitle">{{ $t('components.modal.generic.confirm_text') }}</span> {{ text }}
			</div>
			<div v-if="productName" class="global-modal-generic__product">{{ productName }}</div>

			<div class="global-modal-generic__action">
				<ButtonPrimary :loading="loader.action" class="global-modal-generic__go" @click="makeAction">
					{{ buttonAction || $t('components.modal.generic.action_button') }}
				</ButtonPrimary>
				<ButtonUnderlined v-if="buttonCancel" :loading="loader.cancel" class="global-modal-generic__back" @click="cancelAction">
					{{ buttonCancel || $t('components.modal.generic.cancel_button') }}
				</ButtonUnderlined>
			</div>
		</div>
	</GlobalModal>
</template>

<script setup lang="ts">
const localePath = useLocalePath()
const isOpen = defineModel<boolean>()
const router = useRouter()
const props = defineProps<{
	returnUrl?: string
	text: string
	buttonAction: string
	buttonCancel?: string
	genericTitle?: boolean
	productName?: string
	function?: () => Promise<void> | void
	functionCancel?: () => Promise<void> | void
}>()

const emit = defineEmits<{
	(e: 'action'): void
	(e: 'close'): void
}>()

const makeAction = async () => {
	loader.action = true
	if (props.function) await props.function()
	else emit('action')
	if (props.returnUrl) router.push(localePath(props.returnUrl))
	emit('close')
	isOpen.value = false
	loader.action = false
}

const cancelAction = async () => {
	loader.cancel = true
	if (props.functionCancel) await props.functionCancel()
	if (props.returnUrl) router.push(localePath(props.returnUrl))
	emit('close')
	isOpen.value = false
	loader.cancel = false
}

const loader = reactive({
	action: false,
	cancel: false,
})
</script>

<style lang="scss" scoped src="./Generic.scss"></style>
